import gql from "graphql-tag"

const komentarFragment = gql `
  fragment komentarFragment on Komentar {
        id
        uuid
        komentar
        pengguna_id
        pengguna {
          nama
          jabatan {
            nama
          }
        }
        is_notulen
        komentar_id
        balasanCount
        balasan {
          id
          uuid
          komentar
          pengguna_id
          pengguna {
            nama
            jabatan {
              nama
            }
          }
          disukai(pengguna_id: $pengguna_id){
            id
          }
          sukaCount
          suka{
            id
            pengguna{
              nama
              jabatan{
                nama
              }
            }
          }
          is_notulen
          komentar_id
          created_at
        }
        disukai(pengguna_id: $pengguna_id){
          id
        }
        sukaCount
        suka{
          id
          pengguna{
            nama
            jabatan{
              nama
            }
          }
        }
        is_notulen
        created_at
  }
`

const GET_ALL_KOMENTAR = gql `
  query Komentar($perPage: Int!, $page: Int, $komentar_id: Int, $komentarable_id: Int, $komentarable_type: String, $pengguna_id: Int){
    komentar(first: $perPage, page: $page, komentar_id: $komentar_id, komentarable_id: $komentarable_id, komentarable_type: $komentarable_type){
      data {
        ...komentarFragment
      }
    }
  }
  ${komentarFragment}
`


const CREATE_KOMENTAR = gql `
  mutation Create($input: KomentarCreateInput!,$pengguna_id: Int){
    komentarCreate(input: $input){
      ...komentarFragment
    }
  }
  ${komentarFragment}
`

const UPDATE_KOMENTAR = gql `
  mutation Update($id: ID!,$input: KomentarUpdateInput!){
    komentarUpdate(input: $input, id: $id){
      id
      is_notulen
    }
  }
`

export {
  GET_ALL_KOMENTAR,
  CREATE_KOMENTAR,
  UPDATE_KOMENTAR
}
